import * as React from 'react';
import { cn } from '@/lib/utils/classNames';

/**
 * GGC V2. Tag / Chip — Figma node 169:682 family (Component 02).
 *
 * Spec: r-md (8px), no border, padding 3px 10px, text 9px / 600.
 * CSS class: .ggc-tag + .ggc-tag--{tone}  (defined in components.css)
 */
export type GgcTagTone = 'default' | 'blue' | 'green' | 'orange' | 'purple' | 'red';

export interface GgcTagProps extends React.HTMLAttributes<HTMLSpanElement> {
  tone?: GgcTagTone;
}

const GgcTag = React.forwardRef<HTMLSpanElement, GgcTagProps>(
  ({ className, tone = 'default', ...props }, ref) => {
    return (
      <span
        ref={ref}
        className={cn('ggc-tag-m', tone !== 'default' && `ggc-tag--${tone}`, className)}
        {...props}
      />
    );
  }
);
GgcTag.displayName = 'GgcTag';

export { GgcTag };
